export default {
    "Apto tipo 1": "https://umbra3d.studio/recorridos/prodesa/brisas-de-san-pablo/",
}